import { forwardRef } from 'react'

import { IconProps } from '../../../types/types'

export const ClockSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const { size = 24, ...rest } = props

	return (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<circle cx="12" cy="12" r="9" fill="#4A4A4A" />
			<path
				d="M19.3696 17.1661C18.4811 18.4336 17.2808 19.4505 15.8845 20.1185C14.4882 20.7866 12.9432 21.0833 11.3988 20.9799C9.85441 20.8765 8.36277 20.3765 7.068 19.5283C5.77325 18.6801 4.71913 17.5123 4.00752 16.1377C3.2959 14.7631 2.95083 13.2282 3.00565 11.6813C3.06046 10.1344 3.51331 8.62776 4.32044 7.30699C5.12757 5.98622 6.26169 4.89593 7.61325 4.14148C8.9648 3.38702 10.4881 2.99389 12.0359 3.00007L12 12L19.3696 17.1661Z"
				fill="url(#paint0_linear_14612_35302)"
			/>
			<path d="M12 8V12.5L16 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<defs>
				<linearGradient
					id="paint0_linear_14612_35302"
					x1="1.36364"
					y1="22.35"
					x2="1.36364"
					y2="3"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</svg>
	)
})
